import { render, staticRenderFns } from "./RegionType.vue?vue&type=template&id=60d31014"
import script from "./RegionType.vue?vue&type=script&lang=js"
export * from "./RegionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports